let management = {
  title: 'Gestão',
  associate_user: {
    title: 'Associar Usuário'
  }
};

export default management;
